import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';

@Component({
  selector: 'app-feedback-smiley',
  templateUrl: './feedback-smiley.component.html',
  styleUrls: ['./feedback-smiley.component.scss']
})
export class FeedbackSmileyComponent extends BaseComponent implements OnInit {

  @ViewChild("feedbackModal", {static: false}) feedbackModal;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  contact() {
    this.feedbackModal.open();
  }

}
